// extracted by mini-css-extract-plugin
export default {"productGallery":"AI-z","inQuickShop":"BI-z"};